import { LostPasswordModel__get_CanSubmit, ResetPasswordModel__get_CanSubmit, Msg } from "./Types.fs.js";
import { HTMLAttr, DOMAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { validatedTextBoxWithoutErrorMsg2, validatedPasswordBoxWithoutErrorMsg, spinnerwhite } from "../../../Bfs.Web.Portale/ViewParts.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { value } from "../../fable_modules/fable-library-js.4.19.0/Option.js";
import { GlobalMsg } from "../../../Bfs.Web.Portale/Types.fs.js";

export function submitOnEnter(dispatch) {
    return new DOMAttr(15, [(e) => {
        if (e.key === "Enter") {
            dispatch(new Msg(5, []));
        }
    }]);
}

export const rightSpinner = (() => {
    const children_2 = [react.createElement("div", {
        className: "spacer",
    }), spinnerwhite];
    return react.createElement("div", {
        className: "column is-4 is-form-padded form-column",
    }, ...children_2);
})();

export function submitButton(isLoading, canSubmit, dispatch) {
    let children_2, props;
    return [(children_2 = [(props = [new HTMLAttr(159, ["submit"]), new HTMLAttr(65, ["bfsbutton " + (isLoading ? " is-loading" : "")]), new HTMLAttr(79, [!canSubmit]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(5, []));
    }])], react.createElement("button", keyValueList(props, 1), "Absenden"))], react.createElement("p", {
        className: "is-pulled-right",
    }, ...children_2)), react.createElement("div", {
        className: "spacer",
    })];
}

export function viewResetPassword(model, dispatch) {
    let children_4, children_12;
    const children_14 = [(children_4 = [react.createElement("h2", {}, "Passwort zurücksetzen"), react.createElement("p", {}, "Bitte geben Sie ein neues Passwort ein und wiederholen es.")], react.createElement("div", {
        className: "toppart",
    }, ...children_4)), (children_12 = toList(delay(() => {
        let props_6, children_6;
        return append(singleton((props_6 = [new HTMLAttr(65, ["info-block"]), ["style", {
            maxWidth: "400px",
        }]], (children_6 = [validatedPasswordBoxWithoutErrorMsg("is-tooltip-right", [])((arg_5) => {
            dispatch(new Msg(1, [arg_5]));
        })("Passwort:")("Passwort")("")(model.Password)], react.createElement("p", keyValueList(props_6, 1), ...children_6)))), delay(() => {
            let props_8, children_8;
            return append(singleton((props_8 = [new HTMLAttr(65, ["info-block"]), ["style", {
                maxWidth: "400px",
            }]], (children_8 = [validatedPasswordBoxWithoutErrorMsg("is-tooltip-right", [submitOnEnter(dispatch)])((arg_11) => {
                dispatch(new Msg(2, [arg_11]));
            })("Wiederholung:")("Wiederholung")("")(model.Password2)], react.createElement("p", keyValueList(props_8, 1), ...children_8)))), delay(() => {
                let children_10;
                return append((model.Message != null) ? singleton((children_10 = [value(model.Message)], react.createElement("p", {
                    className: "content",
                }, ...children_10))) : empty(), delay(() => singleton(submitButton(model.Sending, ResetPasswordModel__get_CanSubmit(model), dispatch))));
            }));
        }));
    })), react.createElement("div", {
        className: "bottompart",
    }, ...children_12))];
    return react.createElement("div", {
        className: "is-form-padded paragraphs form-column",
    }, ...children_14);
}

export function viewLostPassword(model, dispatch) {
    let children_4, children_12, children_6, children_10;
    const children_14 = [(children_4 = [react.createElement("h2", {}, "Passwort zurücksetzen"), react.createElement("p", {}, "Bitte geben Sie Ihre E-Mail-Adresse ein, die Sie zur Anmeldung im BFS Kundenportal nutzen.")], react.createElement("div", {
        className: "toppart",
    }, ...children_4)), (children_12 = [(children_6 = [validatedTextBoxWithoutErrorMsg2([submitOnEnter(dispatch)])((arg_5) => {
        dispatch(new Msg(0, [arg_5]));
    })("E-Mail:")("E-Mail")("abc@example.com")(model.Email)], react.createElement("p", {
        className: "info-block",
    }, ...children_6)), (children_10 = [react.createElement("a", {
        onClick: (_arg) => {
            dispatch(new Msg(8, [new GlobalMsg(1, [])]));
        },
    }, "Zurück zur Startseite")], react.createElement("p", {}, ...children_10)), submitButton(model.Sending, LostPasswordModel__get_CanSubmit(model), dispatch)], react.createElement("div", {
        className: "bottompart",
    }, ...children_12))];
    return react.createElement("div", {
        className: "is-form-padded paragraphs form-column",
    }, ...children_14);
}

export function viewMessageModel(model, dispatch) {
    let children_2, children_8, children_6;
    const children_10 = [(children_2 = [react.createElement("p", {}, model.Text)], react.createElement("div", {
        className: "toppart",
    }, ...children_2)), (children_8 = [(children_6 = [react.createElement("button", {
        type: "submit",
        className: "bfsbutton",
        onClick: (_arg) => {
            dispatch(new Msg(8, [new GlobalMsg(1, [])]));
        },
    }, "Zurück zur Startseite")], react.createElement("p", {
        className: "is-pulled-right",
    }, ...children_6))], react.createElement("div", {
        className: "bottompart",
    }, ...children_8))];
    return react.createElement("div", {
        className: "is-form-padded paragraphs form-column",
    }, ...children_10);
}

export function view(model, dispatch, navigateTo) {
    let children;
    const children_2 = [(children = toList(delay(() => ((model.tag === 1) ? singleton(viewResetPassword(model.fields[0], dispatch)) : ((model.tag === 2) ? singleton(viewMessageModel(model.fields[0], dispatch)) : singleton(viewLostPassword(model.fields[0], dispatch)))))), react.createElement("div", {
        className: "loginform is-auto is-auth-form category-header",
    }, ...children))];
    return react.createElement("div", {
        className: "loginform is-auto is-auth-form category-header passwordreset",
    }, ...children_2);
}

//# sourceMappingURL=View.fs.js.map
